export class DailyReportRecipientModel {
    public RecipientId: number;
    public SiteId: number;
    public AccountId: number;
    public ReportType: number;
    public Email: string;
}



// WEBPACK FOOTER //
// ./src/app/models/dailyReportRecipientModel.ts